// extracted by mini-css-extract-plugin
export default {"seriesCount":"SeriesCount_seriesCount__LxhlL"};